export const environment = {
    production: false,
    baseUrl: 'https://sharelog-api.sequens.ch',
    reportingUrl: 'https://sharelog-reporting-api.sequens.ch',
    defaultContext: 'sharelog1',
    useAirlock: false,
    bingMapsApiKey: 'AsnpLBjRvehY9AZoPAYKE9zY6pRSC2WgeQ7SSXxCZy0Ut1XHZIkw-t6tPfdb9-u-',
    users: [
        {
            label: 'Admin',
            userId: 'admin@sharelog.ch',
            password: 'sharelog'
        },
        {
            label: 'Operator',
            userId: 'op1@sharelog.com',
            password: 'sharelog'
        },
        {
            label: 'Netvote User Jacoby Stefania',
            userId: '14113-1053',
            password: 'h1tf42p2'
        },
        {
            label: 'Netvote User Ramseyer Stefania',
            userId: '18026-58',
            password: 'j2ti6v87'
        },
        {
            label: 'Netvote User Gabler Abraham',
            userId: '19615-618',
            password: 'a434qn2r'
        },
        {
            label: 'Netvote User Grosse Stefanie (GL)',
            userId: '90973-1692',
            password: 'g4qpk866'
        }
    ]
};
